<!--
 * @Author: Junjie
 * @Date: 2023-08-27 17:53:21
 * @LastEditTime: 2023-08-27 17:54:18
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/general/docs/modules/PlantDocsModal.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <plant-docs-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></plant-docs-form>
  </j-modal>
</template>

<script>
import PlantDocsForm from './PlantDocsForm.vue'
export default {
  name: 'CommonDocsModal',
  components: {
    PlantDocsForm
  },
  data() {
    return {
      title: '',
      width: 896,
      visible: false,
      disableSubmit: false
    }
  },
  methods: {
    add(docType) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add(docType)
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
